import { ElementType } from "@archetypes/form";
import { MENTION_REGEX } from "@constants/generic";
export const FIELD_ID_SEPERATOR = "$dot$";

export function replaceMentionTagsWithTokenString(htmlString: string, token: string) {
  return htmlString.replace(MENTION_REGEX, (match, id) => {
    return id ? `${token}${id.replaceAll(".", FIELD_ID_SEPERATOR)}` : match;
  });
}

export function extractQuestionIdsFromMentionTag(expression: string | undefined) {
  if (!expression) {
    return [];
  }
  const dataIds = [];
  let match;

  while ((match = MENTION_REGEX.exec(expression)) !== null) {
    dataIds.push(match[1]);
  }

  return dataIds;
}

const MENTION_SPAN_REGEX = /<span\b[^>]*\bdata-id="[^"]*"[^>]*>/g;
const MENTION_DATA_ID_REGEX = /\bdata-id="([^"]*)"/;
const MENTION_DATA_TYPE_REGEX = /\bdata-type="([^"]*)"/;

export function extractQuestionMetaFromMentionTag(htmlString: string | undefined): {
  questionId: string;
  questionType: ElementType;
}[] {
  if (!htmlString) {
    return [];
  }

  const result = [];
  let match;

  while ((match = MENTION_SPAN_REGEX.exec(htmlString)) !== null) {
    const span = match[0];
    const questionId = span.match(MENTION_DATA_ID_REGEX)?.[1];
    const questionType = span.match(MENTION_DATA_TYPE_REGEX)?.[1];

    if (questionId && questionType) {
      result.push({
        questionId: questionId.replaceAll(".", FIELD_ID_SEPERATOR), // mathlib does not support dot notation in variable names, so we replace it with a separator
        questionType: questionType as ElementType,
      });
    }
  }

  return result;
}

export function isQuestionAllowedInFormulaConfig(elementType: ElementType) {
  return (
    elementType === ElementType.Currency ||
    elementType === ElementType.Number ||
    elementType === ElementType.Formula ||
    elementType === ElementType.Rating ||
    elementType === ElementType.Aggregator ||
    elementType === ElementType.DatePicker
  );
}
